
    <ng-container *ngIf="data">
      <app-home *ngIf="componentId === 'homePage'" [data]="data"></app-home>
      <app-content *ngIf="componentId === 'contentPage'" [data]="data"></app-content>
      <app-not-found *ngIf="componentId === 'pageNotFoundPage'" [data]="data"></app-not-found>
      <app-search-result *ngIf="componentId === 'searchResultPage'" [data]="data"></app-search-result>
      <app-news-overview-page *ngIf="componentId === 'newsOverviewPage'" [data]="data"></app-news-overview-page>
      <app-news-details *ngIf="componentId === 'newsDetailsPage'" [data]="data"></app-news-details>
      <app-login *ngIf="componentId === 'loginPage'" [data]="data"></app-login>
    </ng-container>
  